import { render, staticRenderFns } from "./PelletFeedingList.vue?vue&type=template&id=6324aa76&"
import script from "./PelletFeedingList.vue?vue&type=script&lang=js&"
export * from "./PelletFeedingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports